import React from "react";
import HeroImage from "../assets/HeroImage.jpg";
import { FiArrowRight } from "react-icons/fi";
import {Link} from 'react-scroll'

const Home = () => {
  return (
    <div
      name="home"
      className="h-screen w-full bg-gradient-to-b from-black via-black to-gray-800"
    >
      <div className="max-w-screen-lg mx-auto flex flex-col items-center justify-center h-full px-4  md:flex-row">
        <div className="flex flex-col justify-center h-full"> 
          <h2 className=" text-4xl sm:text-7xl font-bold text-white"> I'm a Full Stack Developer</h2>
          <p className="text-gray-500 py-4 max-w-md">
            I have an year of experience of building and desigining web
            application as well as mobile application. Currently, I love to work
            on web & mobile application using React, React-Native,Tailwind CSS, Vue Js.
          </p>
          <div>
            <Link to="portfolio" smooth duration={500} className="group text-black w-fit px-6 py-3 my-2 flex items-center rounded-md
             bg-gradient-to-r from-cyan-300 to-blue-500 cursor-pointer
             hover:scale-105 duration-200"><b>
              Portfolio</b>
              <span className="group-hover:rotate-90 duration-300">
                <FiArrowRight size={25} className="ml-1"/>
              </span>
            </Link>
          </div>
        </div>
        <div className="">
          <img className="rounded-full  mx-auto w-2/3 md:2-full" src={HeroImage} alt="Sagar_image" />
        </div>
      </div>
    </div>
  );
};

export default Home;
